<template>
  <div
    id="popup"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      :class="messageBox.size"
      class="modal-dialog modal-dialog-centered"
      role="document"
    >
      <div ref="modalcontent" class="modal-content">
        <div class="modal-header shadow">
          <div class="tag-badge">
            <span class="dot text-center pl-1">
              <em
                :class="messageBox.icon"
                class="orange-icon orange-icon-badge-align"
              />
            </span>
            <span class="tag-badge-title py-1 pl-3">
              {{ messageBox.title }}
            </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="content">
            <span>{{ Message }}</span>
          </div>
          <div v-if="checkbox != null && checkbox.Show">
            <input
              id="Option3"
              v-model="CheckValue"
              type="checkbox"
              name="Option3"
              class="option-input checkbox"
            />
            <label for="Option3" class="pl-2">
              <span>
                <em class="ic-check" />
              </span>
              {{ checkbox.label }}
            </label>
            <p v-if="showError" class="invalid">
              {{ checkbox.validationMessage }}
            </p>
          </div>
        </div>
        <div class="text-right p-4">
          <div v-if="messageBox.type == null || messageBox.type == 'alert'">
            <div class="text-center">
              <button
                type="button"
                class="btn btn-success btn-green"
                @click="Success()"
              >
                OK
              </button>
            </div>
          </div>
          <div v-else-if="messageBox.type == 'confirm'">
            <button
              type="button"
              class="btn btn-success btn-green btn-si mr-1"
              @click="Success()"
            >
              SI
            </button>
            <button
              type="button"
              class="btn btn-action-danger btn-danger btn-no"
              data-dismiss="modal"
              @click="Cancel()"
            >
              NO
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixwait from '@/mixin/loading.mixin';
import JQuery from 'jquery';
let $ = JQuery;

export default {
  mixins: [mixwait],
  data() {
    return {
      CheckValue: null,
      ConfirmResult: null,
      Message: '',
      showError: false,
    };
  },
  props: {
    messageBox: {
      type: Object,
      default: function() {
        return {};
      },
    },
    checkbox: {
      type: Object,
      default: function() {
        return {};
      },
    },
    successCallback: {
      type: Function,
      default: () => {},
    },
    cancelCallback: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    Success() {
      let self = this;
      if (!!self.checkbox && self.checkbox.isRequired && !self.CheckValue) {
        self.showError = true;
        return;
      }

      this.showError = false;
      self.successCallback(this.CheckValue);
      $('#popup').modal('hide');
    },
    Cancel() {
      let self = this;
      self.cancelCallback();
    },
    GetMessageWithCode() {
      let self = this;
      if (self.messageBox && self.messageBox.messageCode) {
        self
          .$ApiGet('/api/validationsmessages/', {
            messageCodes: self.messageBox.messageCode,
          })
          .then((response) => {
            let result = response.data.shift();
            self.Message = result.name;
          });
      }
    },
  },
  mounted() {
    let self = this;
    if (self.messageBox.messageCode != '' && !self.messageBox.message) {
      self.GetMessageWithCode();
    } else {
      self.Message = self.messageBox.message;
    }
  },
};
</script>

<style scoped>
.btn-green {
  background-color: #2db782;
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  color: #ffffff;
  border-radius: 4px;
  border: none;
  margin-left: 2.5px;
}
.btn-green:hover {
  font-weight: bold;
}
.btn-si,
.btn-no {
  height: 45px;
  width: 49px;
}
.btn-si:hover,
.btn-no:hover {
  font-weight: bold;
}
.btn-danger {
  color: #ffffff;
  background-color: #c9545e;
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  color: #ffffff;
  border-radius: 4px;
  border: none;
}
.outline-danger {
  color: #c9545e;
  background-color: #ffffff;
  border-color: #c9545e;
}
.outline-danger:hover {
  color: #ffffff;
  background-color: #c9545e;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  padding-bottom: 0.5%;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
}

.dot {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #00000029;
  padding-top: 7px;
}
.orange-icon {
  color: #ff7058;
  font-size: 15pt;
  padding-right: 4px;
  line-height: 23px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.input-group .option-input {
  display: none;
}

.input-group .option-input + label span {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: -2px 10px 0 0;
  vertical-align: middle;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  cursor: pointer;
}
.input-group .option-input:checked + label span .ic-check {
  background: url('/assets/img/icon-check-solid.svg');
  background-size: cover;
  display: flex;
  width: 18px;
  height: 14px;
  margin: 2px auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.invalid {
  color: #e85c5c !important;
}

.modal-body .content {
  text-align: left;
  border-radius: 4px;
  opacity: 1;
  margin: 20px 33px 0px 33px;
  padding: 22px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
}
</style>
